// extracted by mini-css-extract-plugin
export default {"bursary":"bursary_bursary__LoH9r","formLabel":"bursary_formLabel__Fx3LU","header":"bursary_header__e-KaS"};